
var selectors = require("./selectors");
var triggerHtml = 
`<div class='header-trigger' id='${selectors.trigger.replace("#", "")}'>
    <i class="fa fa-bars"></i>
    <span>Menu</span>
</div>`;

var dropdownArrow = `<span class='header-dropdownArrow'></span>`;

var actions = {
    close: function(e) {
        $(selectors.menuWrapper).removeClass("open");
        // wait to close submenu until slide left is done
        setTimeout(() => $(selectors.activeHeaders).removeClass("active"), 300);
    },
    open: function() {
        $(selectors.menuWrapper).toggleClass("open");
    },
    dropdownToggle: function(e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(this)
        var isActive = $this.parent().hasClass("active")
        $(selectors.activeHeaders).removeClass("active");
        if (!isActive) $this.parent().addClass("active");
    }
}

var create = function(container, triggerClick) {
    container = container || selectors.menuWrapper;

    var component = { actions, $container: $(container) };
    // Add the menu trigger
    component.$container.addClass('header-section').prepend(triggerHtml);
    // set a max height on dropdown menus for mobile scrolling. shouldn't effect desktop
    $(selectors.dropdownMenu).css("max-height", window.innerHeight - 70 + "px");

    // Add the menu dropdown arrows
    $(selectors.headers + " > a.menu-item").after(dropdownArrow);
    $(selectors.trigger).on("click", function(e) {
        e.stopPropagation();
        $(document).trigger("header-section-toggle", component);
    });
    //expand sub menus on click
    //$(selectors.headers).on("click", actions.dropdownToggle);
    $(selectors.headers + " > .header-dropdownArrow").on("click", actions.dropdownToggle);
    // allow links to redirect as normal
    $(selectors.dropdownLinks).on("click", (e) => e.stopPropagation());
    
    return component;
}


module.exports = { create };


// WEBPACK FOOTER //
// ./src/scripts/components/topNav/index.js